import * as actions from "../actionTypes"

// last modified timestamp
const initialState = {
  modified: undefined,
}

export default function commentsLastModified(state = initialState, action) {
  switch (action.type) {
    case actions.SET_COMMENTS_LAST_MODIFIED: {
      return {
        ...state,
        value: action.payload.value,
      }
    }

    default:
      return state
  }
}
